export default "__VITE_ASSET__b3341d5a__"